// Read the subscription variant map that Liquid rendered
window.ccHasSellingPlan = function (variantId) {
  if (!window.ccSubscriptionMap) {
    try {
      const el = document.getElementById('cc-subscription-map');
      window.ccSubscriptionMap = el ? JSON.parse(el.textContent) : {};
    } catch {
      window.ccSubscriptionMap = {};
    }
  }
  return !!window.ccSubscriptionMap[variantId];
};

// Remove upgrade buttons for variants without selling plans
window.ccFilterSubscriptionButtons = function () {
  document.querySelectorAll('.js-upgrade-to-subscription').forEach(btn => {
    const id = btn.getAttribute('data-variant-id');
    if (!window.ccHasSellingPlan(id)) btn.remove();
  });
};


(function () {
  function updateSellingPlanForLine(lineIndex, variantId, quantity, newSellingPlanId) {
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    };

    // 1. Remove the current line by line index
    return fetch('/cart/change.js', {
      method: 'POST',
      headers,
      body: JSON.stringify({
        line: Number(lineIndex),   // 👈 use line, not id
        quantity: 0
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to remove cart line');
        return res.json();
      })
      .then(function () {
        // 2. Add the variant back with or without selling_plan
        var payloadItem = {
          id: Number(variantId),
          quantity: Number(quantity)
        };

        if (newSellingPlanId !== null) {
          payloadItem.selling_plan = Number(newSellingPlanId);
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ items: [payloadItem] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to re-add with new selling plan');
        return res.json();
      });
  }

  function getLineContext(el) {
    var row = el.closest('.line-item');

    var lineIndex =
      (row && row.dataset.lineIndex) ? Number(row.dataset.lineIndex) : null;

    var variantId =
      el.dataset.variantId ||
      (row && row.dataset.variantId) ||
      null;

    var qtyStr =
      el.dataset.initialQty ||
      (row && row.dataset.initialQty) ||
      null;

    var qty = qtyStr ? Number(qtyStr) : 1;

    return { row: row, lineIndex: lineIndex, variantId: variantId, qty: qty };
  }

  function refreshAjaxCart() {
    var path = window.location.pathname.replace(/\/+$/, '');
    var isCartTemplate = (path === '/cart');

    if (isCartTemplate) {
      window.location.reload();
      return;
    }

    if (window.Cart &&
        typeof Cart.getCart === 'function' &&
        typeof Cart.buildCart === 'function') {
      Cart.getCart(Cart.buildCart);
      if (typeof Cart.updateCartTotal === 'function') {
        Cart.updateCartTotal();
      }
    } else {
      window.location.reload();
    }
  }

  // 1) Select change → switch plan or one-time
  document.addEventListener('change', function (evt) {
    var select = evt.target.closest('.js-selling-plan-selector');
    if (!select) return;

    var ctx = getLineContext(select);
    var rawValue  = select.value;
    var newPlanId = rawValue === '' ? null : rawValue; // "" → one-time

    if (!ctx.lineIndex || !ctx.variantId) {
      console.warn('Missing line index or variant id for selling plan change', ctx);
      return;
    }

    if (ctx.row) ctx.row.classList.add('is-updating-selling-plan');

    updateSellingPlanForLine(ctx.lineIndex, ctx.variantId, ctx.qty, newPlanId)
      .then(function () {
        if (ctx.row) ctx.row.classList.remove('is-updating-selling-plan');
        refreshAjaxCart();
      })
      .catch(function (err) {
        console.error('Error updating selling plan:', err);
        if (ctx.row) ctx.row.classList.remove('is-updating-selling-plan');
      });
  });

  // 2) Button click → upgrade one-time → subscription
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.js-upgrade-to-subscription');
    if (!btn) return;

    var ctx           = getLineContext(btn);
    var defaultPlanId = btn.dataset.defaultPlanId; // e.g. 691019317531

    if (!ctx.lineIndex || !ctx.variantId || !defaultPlanId) {
      console.warn('Missing data to upgrade to subscription', ctx, defaultPlanId);
      return;
    }

    if (ctx.row) ctx.row.classList.add('is-updating-selling-plan');

    updateSellingPlanForLine(ctx.lineIndex, ctx.variantId, ctx.qty, defaultPlanId)
      .then(function () {
        if (ctx.row) ctx.row.classList.remove('is-updating-selling-plan');
        refreshAjaxCart();
      })
      .catch(function (err) {
        console.error('Error upgrading to subscription:', err);
        if (ctx.row) ctx.row.classList.remove('is-updating-selling-plan');
      });
  });
})();


// Prevent app-embed-block.js from throwing on themes where selectors differ
document.addEventListener('DOMContentLoaded', () => {
  const origUpdateFn = window.updatePriceAndSellingPlanInfo;

  // Only wrap if Shopify's function exists
  if (typeof origUpdateFn === 'function') {
    window.updatePriceAndSellingPlanInfo = function (...args) {
      try {
        return origUpdateFn.apply(this, args);
      } catch (err) {
        // Intercept the null appendChild error (and any others)
        if (err.message?.includes('appendChild')) {
          return; // swallow the error so it doesn’t break other scripts
        }
        throw err; // rethrow other errors normally
      }
    };
  }
});

/*
  Clayton Coffee – Subscription Dropdown + Price Reset + Safe Label Update
*/

document.addEventListener("DOMContentLoaded", function () {

  function initSubscriptionDropdowns() {
    document.querySelectorAll(".shopify_subscriptions_app_block").forEach(block => {

      const subscribeRadio = block.querySelector('input[data-radio-type="selling_plan_group"]');
      const oneTimeRadio   = block.querySelector('input[data-radio-type="one_time_purchase"]');
      const childrenBlock  = block.querySelector('.shopify_subscriptions_app_block_label_children ul');

      if (!subscribeRadio || !childrenBlock) return;

      if (block.dataset.ccDropdownInitialized === "true") return;
      block.dataset.ccDropdownInitialized = "true";

      // ⭐ Fix: Update Subscribe & Save label TEXT ONLY (do NOT replace innerHTML)
      const subscribeLabel = subscribeRadio.closest("label");
      if (subscribeLabel) {
        // Remove existing text without touching the <input>
        const inputEl = subscribeLabel.querySelector("input");
        subscribeLabel.innerHTML = "";
        subscribeLabel.appendChild(inputEl);

        // New label text
        const text = document.createTextNode(" Subscribe and Save (10% off & Free Shipping)");
        subscribeLabel.appendChild(text);
      }

      // ⭐ Build dropdown
      const select = document.createElement("select");
      select.className = "cc-subscription-dropdown";
      select.style.display = "none";

      // Build the dropdown options & remove "10% off"
      childrenBlock.querySelectorAll("li input[data-radio-type='selling_plan']").forEach(input => {
        let text = input.parentElement.innerText.trim();
        text = text.replace(/,\s*10%\s*off/gi, "").trim(); // remove 10% off

        const opt = document.createElement("option");
        opt.value = input.dataset.sellingPlanId;
        opt.textContent = text;
        select.appendChild(opt);
      });

      childrenBlock.parentElement.insertBefore(select, childrenBlock);
      childrenBlock.style.display = "none";

      // Shopify’s hidden selling plan input
      const hiddenPlanInput = document.querySelector("input.selected-selling-plan-id");

      // Price handling
      const compareEl = document.querySelector("[data-compare-price]");
      const priceEl = document.querySelector("[data-product-price]");

      function showOneTimePrice() {
        if (compareEl) compareEl.style.display = "none";
        if (priceEl) priceEl.style.display = "block";
      }

      function showSubscribePrice() {
        if (compareEl) compareEl.style.display = "";
      }

      // One-time purchase selected
      oneTimeRadio.addEventListener("change", () => {
        if (oneTimeRadio.checked) {
          select.style.display = "none";
          hiddenPlanInput.value = "";
          showOneTimePrice();
        }
      });

      // Subscribe selected
      subscribeRadio.addEventListener("change", () => {
        if (subscribeRadio.checked) {
          select.style.display = "block";
          hiddenPlanInput.value = select.value;
          showSubscribePrice();
        }
      });

      // Dropdown selection updates selling_plan
      select.addEventListener("change", () => {
        hiddenPlanInput.value = select.value;
      });
    });
  }

  initSubscriptionDropdowns();

  // Motion theme AJAX reload
  document.addEventListener("product:variant-change", initSubscriptionDropdowns);
});

/*
  Clayton Coffee – Reset to One-Time Purchase when Grind or Weight changes
  + Ensure sale price shows when Subscribe & Save is clicked
*/

document.addEventListener("DOMContentLoaded", function () {

  function getActiveSubscriptionBlock() {
    return document.querySelector(
      ".shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)"
    );
  }

  function hideSalePrice() {
    const wrapper = document.querySelector("[data-price-wrapper]");
    if (!wrapper) return;

    const compareEl = wrapper.querySelector("[data-compare-price]");
    const priceEl = wrapper.querySelector("[data-product-price]");

    if (compareEl) {
      compareEl.classList.add("visually-hidden");
      compareEl.style.display = "none";
    }
    if (priceEl) {
      priceEl.style.display = "block";
    }
  }

  function showSalePriceForSubscription() {
    const wrapper = document.querySelector("[data-price-wrapper]");
    if (!wrapper) return;

    let compareEl = wrapper.querySelector("[data-compare-price]");

    // If Motion nuked it, rebuild it
    if (!compareEl) {
      compareEl = document.createElement("s");
      compareEl.className = "product-price__sale product-single__price--compare-at";
      compareEl.setAttribute("data-compare-price", "");
      wrapper.appendChild(compareEl);
    }

    // Make sure it's visible
    compareEl.classList.remove("visually-hidden");
    compareEl.style.display = "";
  }

  function resetToOneTimePurchase() {
    const activeBlock = getActiveSubscriptionBlock();
    if (!activeBlock) return;

    const oneTimeRadio = activeBlock.querySelector('input[data-radio-type="one_time_purchase"]');
    const subscribeRadio = activeBlock.querySelector('input[data-radio-type="selling_plan_group"]');
    const dropdown = activeBlock.querySelector(".cc-subscription-dropdown");
    const hiddenPlanInput = document.querySelector("input.selected-selling-plan-id");

    // Reset radio selection in the ACTIVE block
    if (oneTimeRadio) oneTimeRadio.checked = true;
    if (subscribeRadio) subscribeRadio.checked = false;

    // Hide dropdown for this block
    if (dropdown) dropdown.style.display = "none";

    // Clear selling plan
    if (hiddenPlanInput) hiddenPlanInput.value = "";

    // Reset price view (hide sale, show regular)
    hideSalePrice();
  }

  // Event delegation for GRIND + WEIGHT changes
  document.addEventListener("change", function (event) {
    const target = event.target;

    // Grind select (option1)
    if (
      target.matches('.selector-wrapper[data-option="option1"] select[data-single-option-selector]')
    ) {
      resetToOneTimePurchase();
    }

    // Weight select (option2)
    if (
      target.matches('.selector-wrapper[data-option="option2"] select[data-single-option-selector]')
    ) {
      resetToOneTimePurchase();
    }

    // Any Subscribe & Save radio
    if (target.matches('input[data-radio-type="selling_plan_group"]')) {
      if (target.checked) {
        showSalePriceForSubscription();
      }
    }
  });

  // Motion theme variant change → also reset to one-time
  document.addEventListener("product:variant-change", function () {
    resetToOneTimePurchase();
  });

});







